import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

export interface SearchInformation {
  searchInformation: {
    stops: Array<any>;
    pois: Array<any>;
    directions: Array<any>;
    others: Array<any>;
  },
  txtSearched: string;
  inputSelected: number | null;
}

const initialState : SearchInformation = {
  searchInformation: {
    stops: [],
    pois: [],
    directions: [],
    others: []
  },
  txtSearched:'',
  inputSelected:null
};

export const searchSlice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    updateTxtSearched: (state, action) => {
      state.txtSearched = action.payload;
    },
    updateInput: (state, action) => {
      state.inputSelected = action.payload;
    },
    updateStops: (state, action) => {
      state.searchInformation.stops = action.payload;
    },
    updatePois: (state, action) => {
      state.searchInformation.pois = action.payload;
    },
    updateDirections: (state, action) => {
      state.searchInformation.directions = action.payload;
    },
    updateOthers: (state, action) => {
      state.searchInformation.others = action.payload;
    },

    resetAll: (state) => {
      state.searchInformation = {
        stops: [],
        pois: [],
        directions: [],
        others: [],
      };
    }
  },
});

export const searchInformation = (state: RootState) => state.searchSlice.searchInformation;
export const inputSelected = (state: RootState) => state.searchSlice.inputSelected;
export const txtSearched = (state: RootState) => state.searchSlice.txtSearched;
